import React from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';

function getFirstNonEmptyValue(obj) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && obj[key] !== '') {
      return obj[key];
    }
  }
  return undefined;
}

const formatKey = (key) => {
  if (key === "sourcename") return "Name";
  if (key === "sourcecountry") return "Country";
  if (key === "accountnumber") return "Account number";
  if (key === "routingnumber") return "Routing number";
  return key;
};

export default function VerificationTable({ status, type }) {
  VerificationTable.propTypes = {
    status: PropTypes.object,
    type: PropTypes.string,
  };
  const isUtility = type === 'utility';
  const prefix = isUtility ? 'utility' : 'bank';

  const verify = status?.[`${prefix}_verify`];
  const verifyCallback = status?.[`${prefix}_verify_callback`];
  const badDoc = status?.[`${prefix}_bad_doc`];
  const verifyDetails = status?.[`${prefix}_verify_details`];
  const verifyJson = status?.[`${prefix}_verify_json`];

  return (
    <div className='table_data'>
      <TableContainer>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className='table-bg-color'>Status</TableCell>
              <TableCell className='table-padding-left capital-letter'>
                {verify === "completed" && verifyCallback === true && !badDoc && verifyDetails !== "bypassDoc" && verifyJson?.pdfdata && "Document processed successfully."}
                {verify === "completed" && verifyCallback === true && !badDoc && verifyDetails !== "bypassDoc" && !verifyJson?.pdfdata && "Session purged — no longer available."}
                {verify === "completed" && verifyCallback === false && "Document under processing."}
                {verifyDetails === "bypassDoc" && "Document submission bypassed."}
                {verify === "completed" && badDoc && verifyCallback === true && <span className='bad-doc-text'> Bad document submitted. <br />Reason: {verifyJson?.message} </span>}
                {verify === false && "No document submitted."}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className='table-bg-color'>Session Id</TableCell>
              <TableCell className='table-padding-left'>{verifyDetails}</TableCell>
            </TableRow>
            {verifyCallback === true && verifyJson?.pdfdata?.map((item, index) => (
                <TableRow key={item?.id || item?.type || `pdf-${index}`}>
                  <TableCell className='table-bg-color capital-letter'>{item?.type}</TableCell>
                  {item?.type === "account" || item.type === "source" ? (
                    <TableCell className='table-padding-left'>
                      {item?.values?.map((innerItem, innerIndex) => {
                        // Try to use a unique key from innerItem, fallback to index
                        const innerKey = innerItem?.id || Object.values(innerItem).join('-') || `inner-${innerIndex}`;
                        return (
                          <div className='tablecell-child' key={innerKey}>
                            {Object.entries(innerItem)
                              .filter(([key, value]) => typeof value === 'string' && value.trim() !== '')
                              .map(([key, value]) => (
                                <div key={key}>
                                  <div className='capital-letter'>{`${formatKey(key)}:  ${value}`}</div>
                                </div>
                              ))}
                          </div>
                        );
                      })}
                    </TableCell>
                  ) : (
                    <TableCell className='table-padding-left'>{getFirstNonEmptyValue(item?.values[0])}</TableCell>
                  )}
                </TableRow>
              ))
            }
            <TableRow>
              <TableCell className='table-bg-color'>Notes</TableCell>
              <TableCell className='table-padding-left'></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
